var exports = {
  "kL": "x93eb46d8--b65280--container",
  "DD": "x93eb46d8--b65280--title",
  "p_": "x93eb46d8--b65280--list",
};

module.exports = exports;
